import styled from 'styled-components/macro';


export const Container = styled.footer`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #485461;
    background-image: linear-gradient(315deg, #485461 0%, #28313b 74%);
    max-width: 100%;
    padding: 1rem 0;
    margin-top: 20rem;
    position : relative;
`;

export const Text = styled.p`
    color: #ffffff;
`;